import { DEFAULT_MARKET_ID } from 'constants/locale'
import { callPlanet } from './'

// export type MemberApiResponse = {
//   +env: string,
//   +version: number,
//   +device: DeviceType,
//   +member: MemberInfo,
//   +mediaBaseUrl: string,
//   +fileBaseUrl: string,
//   +operationId: number,
//   +operationCode: string
// }

// export type MemberApiRequest = {
//   +response: MemberApiResponse
// }

// type FetchMemberInit = (
//   cypherSSO: string,
//   device: DeviceType
// ) => Observable<MemberApiRequest>

export const fetchMemberInit = (
  cypherSSO,
  device = 'web'
) => callPlanet(`Init?cyphersso=${encodeURIComponent(cypherSSO)}&device=${device}`)

// type FetchMember = (
//   opeCode: string,
//   marketId?: string,
//   partner: string,
//   locale: string,
//   device?: DeviceType
// ) => Observable<MemberApiRequest>

export const fetchMember = (
  opeCode,
  marketId = DEFAULT_MARKET_ID,
  partner,
  locale,
  device = 'web'
) => callPlanet(`Member/${opeCode}/${marketId}/${partner}/${locale}/${device}`)
